import {format} from "date-fns";
import VueCookies from "vue-cookies";

export const TenantModule = {
    namespaced: true,
    state: {
        sis_storage: VueCookies.get("tenant_sis_storage") || null,
        uuid: null,
        id: VueCookies.get("lmsTenantId") || null,
        school_name: "GenEx",
        is_white_labeled: VueCookies.get("tenant_is_white_labeled") || "0",
        show_tenant_assets: true,
    },
    actions: {
        logout({commit}) {
            commit("clearTenantData");
        }
    },
    mutations: {
        setTenantData(state, tenant) {
            state.sis_storage = tenant.sis_storage;
            state.uuid = tenant.uuid;
            state.id = tenant.id;
            state.school_name = tenant.school_name;
            state.is_white_labeled = tenant.is_white_labeled ?? "1";
        },
        clearTenantData(state) {
            state.sis_storage = null;
            state.uuid = null;
            state.id = null;
            state.school_name = "GenEx";
            state.is_white_labeled = "0";
        },
        showAssets(state, show){
            state.show_tenant_assets = show;
        },
    },
    getters: {
        isCentral: state => {
            if (state.forceCentral) {
                return true;
            }
            return window.location.hostname.includes("sis-central");
        },
        defaultFavIconUrl: () => {
            return "https://generation-sis-assets.s3.eu-west-1.amazonaws.com/images/genex-logo-04.svg";
        },
        faviconUrl: state => {
            if (state.sis_storage) {
                return (
                    `https://${state.sis_storage.bucket}.${state.sis_storage.driver}.${state.sis_storage.region}.amazonaws.com/dynamic-assets/images/site-logo-favicon.svg` +
                    "?cache-bust=" +
                    format(new Date(), "yyyy-MM-dd-HH")
                );
            }
            return "https://generation-sis-assets.s3.eu-west-1.amazonaws.com/images/genex-logo-04.svg";
        },
        collapsedLogoUrl: state => {
            if (state.sis_storage) {
                return (
                    `https://${state.sis_storage.bucket}.${state.sis_storage.driver}.${state.sis_storage.region}.amazonaws.com/dynamic-assets/images/site-logo-collapsed.svg` +
                    "?cache-bust=" +
                    format(new Date(), "yyyy-MM-dd-HH")
                );
            }
            return "https://generation-sis-assets.s3.eu-west-1.amazonaws.com/images/genex-logo-04.svg";
        },
        expandedLogoUrl: state => {
            if (state.sis_storage) {
                return (
                    `https://${state.sis_storage.bucket}.${state.sis_storage.driver}.${state.sis_storage.region}.amazonaws.com/dynamic-assets/images/site-logo-expanded.svg` +
                    "?cache-bust=" +
                    format(new Date(), "yyyy-MM-dd-HH")
                );
            }
            return "https://generation-sis-assets.s3.eu-west-1.amazonaws.com/images/genex-logo-03.svg";
        },
        applyImage: state => {
            if (state.sis_storage) {
                return (
                    `https://${state.sis_storage.bucket}.${state.sis_storage.driver}.${state.sis_storage.region}.amazonaws.com/dynamic-assets/images/apply-image.jpg` +
                    "?cache-bust=" +
                    format(new Date(), "yyyy-MM-dd-HH")
                );
            }
            return "https://generation-sis-assets.s3-eu-west-1.amazonaws.com/images/sis-image-gs.jpg";
        },
        applyLogoUrl: state => {
            if (state.sis_storage) {
                return (
                    `https://${state.sis_storage.bucket}.${state.sis_storage.driver}.${state.sis_storage.region}.amazonaws.com/dynamic-assets/images/apply-logo.svg` +
                    "?cache-bust=" +
                    format(new Date(), "yyyy-MM-dd-HH")
                );
            }
            return "https://generation-sis-assets.s3.eu-west-1.amazonaws.com/images/genex-logo-02.svg";
        },
        applicationTAndC: state => {
            if (state.sis_storage) {
                return `https://${state.sis_storage.bucket}.${state.sis_storage.driver}.${state.sis_storage.region}.amazonaws.com/dynamic-assets/documents/application-terms-and-conditions.pdf`;
            }
            return null;
        },
        altApplicationTAndC: state => {
            if (state.sis_storage) {
                return `https://${state.sis_storage.bucket}.${state.sis_storage.driver}.${state.sis_storage.region}.amazonaws.com/dynamic-assets/documents/alternative-qualification-application-terms-and-conditions.pdf`;
            }
            return null;
        },
        privacyPolicy: state => {
            if (state.sis_storage) {
                return `https://${state.sis_storage.bucket}.${state.sis_storage.driver}.${state.sis_storage.region}.amazonaws.com/dynamic-assets/documents/privacy-policy.pdf`;
            }
            return "https://generation-sis-assets.s3.eu-west-1.amazonaws.com/downloads/GenEx+Privacy+Policy+.pdf";
        },
        releasesLogoUrl: () => {
            return "https://genex-web-assets.s3.eu-west-1.amazonaws.com/GenEx_WN_Graphic.svg";
        },
        isWhiteLabeled: state => {
            return parseInt(state.is_white_labeled) === 1;
        },
    },
};
